<template>
  <div>
    <h1 class="better_font">Parents/Guardians</h1>
    <div v-for="guardian in guardians" v-bind:key="guardian.id">
      <Guardian :guardian_data="guardian" />
    </div>
    <div v-if="guardians.length < 2">
      <button class="btn btn-primary btn-form better_font" @click="addGuardian" type="button">Add Guardian</button>
    </div>
  </div>
</template>

<script>
import axios from "axios"
import Guardian from "./Guardian.vue"
export default {
  name: "guardians",
  components:{
    Guardian
  },
  data(){
    return{
      guardians: [],
      errors: []
    }
  },
  mounted(){
    this.getGuardians()
  },
  methods:{
    getGuardians(){
      axios.get(`${process.env.VUE_APP_ENDPOINT}/api/applicant/profile/guardians/`)
      .then( res => {
        this.guardians = res.data.guardians
      })
      .catch( err => {
        this.errors.push(err)
      })
    },
    addGuardian(){
      let new_guardian = { }
      this.guardians.push(new_guardian)
    }
  }
}
</script>

<style scoped>

.btn-form {
  background-color: #27AAE1;
  color: white;
}

.btn-form:hover {
  background-color: #1B86B5;
}

</style>
